function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ItemText } from '@radix-ui/react-select';
import * as S from './SelectItem.styles';
const SelectItem = /*#__PURE__*/React.forwardRef(({
  children,
  grouped,
  isPlaceholder,
  size,
  ...props
}, ref) => {
  return /*#__PURE__*/React.createElement(S.SelectItemWrapper, {
    $isDisabled: props.disabled
  }, /*#__PURE__*/React.createElement(S.SelectItemContainer, _extends({
    ref: ref,
    $isPlaceholder: isPlaceholder,
    $size: size
  }, props), /*#__PURE__*/React.createElement(S.SelectItemTextContainer, {
    $grouped: grouped,
    $isPlaceholder: isPlaceholder
  }, /*#__PURE__*/React.createElement(ItemText, {
    "aria-disabled": props.disabled
  }, children))));
});
export { SelectItem };